import { handleAds } from ".";
import { throwErrorWithStack } from "../crashlytics";
import { getLogger } from "../logging";
import { inAppPurchases } from "../plugins";
import store from "../store";

const log = getLogger("Subscription");

const _processProduct = async ({ completed, pending, verified, productId }) => {
  if (pending || !verified) return false; // not paid yet, complete later
  if (!completed) {
    log.info(`Completing purchase for ${productId}`);
    const product = await inAppPurchases.completePurchase(productId);
    return _processProduct(product);
  } else {
    log.info(`Active subscription for ${productId} found`);
    return true;
  }
};

export async function handleSubscribed() {
  if (inAppPurchases == undefined) return;
  try {
    const products = await inAppPurchases.restorePurchases();
    const subscribed = products.some(_processProduct);
    if (subscribed) {
        log.info("Removed ads due to existing subscription");
        store.set("removedAds", true);
        handleAds();
    }
  } catch (error) {
    throwErrorWithStack(error);
  }
}
